import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';

import { Subscription } from 'rxjs';
import { CommonTableActionPermission } from 'src/app/core/model';
import { DataService } from '../../common-services/data.service';
import { LoaderHandlerService } from '../../common-services/overlay-loader-service/loader-handler.service';
import { SharedService } from '../../common-services/shared.service';


export interface Element {
  alertId: string,
  alertDesc: string,
  class: string,
  type: string,
  alertSeverity: string,
  alertCategory: string,
  index: string,
  groupName: string,
  privilege: string,
  menu: string,
  featureName: string,
  featureReleasedOn: string,
  featureId: string,
  featureType: string,
  action: string
}

@Component({
  selector: 'app-common-table',
  templateUrl: './common-table.component.html',
  styleUrls: ['./common-table.component.css']
})
export class CommonTableComponent implements OnInit, OnChanges, OnDestroy {

  @Input() tableData: any;

  @Input() dataSet: any;

  @Input() columnHeader: any;

  @Input() isOpacityChanged: boolean = false;

  @Input() pageType: any;

  @Input() addBatchEnable: boolean = false;

  @Input() addTemplateEnable: boolean = false;

  @Input() addDeviceFlag: boolean = false;

  @Input() timeWithinSchedule: boolean[] = [];

  @Input()
  set actionPermission(value: Partial<CommonTableActionPermission>) {
    value = { ...value, showPaginator: (value?.hasOwnProperty('showPaginator')) ? value?.showPaginator : true };
    if (Object.keys(value).length - 2 > 2) {
      const { firstTwoAttributes, remainingAttributes } = this.extractFirstTwoAttributes(value);

      this._actionPermission = firstTwoAttributes;
      this.elipsesActionPermission = remainingAttributes;
      this._actionPermission['toggle'] = true;
    }
    else {
      this._actionPermission = value;
    }
  }

  @Input() tableClass;

  get actionPermission() {
    return this._actionPermission;
  }

  @ViewChild(MatSort, { static: false }) sort!: MatSort;
  @ViewChild(MatPaginator, { static: false }) paginator!: MatPaginator;
  @Output() tableAction = new EventEmitter<any>();
  @Output() searchAction = new EventEmitter<any>();

  loadStatus: boolean = true;
  dataSource = new MatTableDataSource([]);
  error: boolean = false;
  objectKeys = Object.keys;
  pageIndex: number = 0;
  pageSize: number = 10;
  pageSizeOptions: any = [10, 20, 30, 100];
  filterLabel: string = 'Attribute/Description/Value/Scope';
  allTenants: boolean = true;
  elipsesActionPermission: Partial<CommonTableActionPermission>;

  // Field
  fieldList = ['attribute', 'values', 'alertId', 'featureId', 'index', 'privilege', 'countOfRecords', 'daysToAge', 'edgeAgent_used_memory_bytes', 'edgehub_connected_clients', 'latColumnName', 'lngColumnName',
    'recordsArchived', 'startTime', 'endTime', 'columnName', 'archiveTillDate', 'jobStartTime', 'jobEndTime', 'reportingIntervalInMs','samplingIntervalInMs', 'startValue', 'endValue', 'inputValue', 'stepValue', 'createdDate', 'expiryDate', 'modifiedDate',
    'upperThreshold', 'noOfDecimals', 'fieldLength', 'lowerThreshold', 'trendNoiseLevel', 'noiseLevel', 'initialValue', 'seasonalityAmplitude', 'trendSlope', 'cumulative', 'carryForward', 'key', 'name', 'behaviour'];
  dateTimeFieldList = ['archiveTillDate'];
  statusFieldList = ['status', 'jobStatus', 'runningStatusRenderer'];
  nonCaseFieldList = ['deviceName', 'timeTaken', 'timeOfSnapshot', 'templateId', 'description', 'serialNumber', 'batchId', 'longitude', 'latitude', 'templateName'];
  errorIconField = ['warningStatus', 'formFillStatus'];
  configurationsList = ['configurations'];
  private _actionPermission: Partial<CommonTableActionPermission>;
  private _subscription: Subscription;

  constructor(
    public sharedService: SharedService,
    private _router: Router,
    private _loaderHandler: LoaderHandlerService,
    private _dataService: DataService
  ) {
    this._subscription = this._loaderHandler.handler$.subscribe((value) => {
      this.loadStatus = value;
    });
    this.tenantCheck();
    this._subscription = this._dataService?.events?.subscribe((res: any) => {
      if (res?.name === 'apiRefresh' || res.name === 'tenantChanged') {
        this.tenantCheck();
      }
    });
  }

  ngOnInit(): void {
    const url = this._router.url.split('/');
    this.filterLabel = url[url.length - 1] === 'userGroup' ? 'Index/User Group' : url[url.length - 1] === 'archivalStatus' ? 'Index/Class/Process' : 'All';
    if (this.dataSet) {
      this._filterTable();
    }
  }

  /**
        * action Button control 
        * @param actionPermissionList
        */
  extractFirstTwoAttributes(obj) {
    const firstTwoAttributes = {};
    const remainingAttributes = {};
    let count = 0;
    for (const key in obj) {
      if (count < 2) {
        firstTwoAttributes[key] = obj[key];
      } else {
        remainingAttributes[key] = obj[key];
      }
      count++;
    }
    return { firstTwoAttributes, remainingAttributes };
  }

  /**
       * Filter 
       * @param event
       */
  applyFilter(event: any) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
    this.pagination(this._getPaginateChange());
  }

  /* Go To page functionality */
  gotoFunctionality(event?: any) {
    const page = (this.paginator.length % this.paginator.pageSize) > 0 ?
      Math.floor(this.paginator.length / this.paginator.pageSize) + 1 : Math.floor(this.paginator.length / this.paginator.pageSize);
    if (event <= page) {
      this.paginator.pageIndex = event - 1;
      this.paginator.page.next(this._getPaginateChange());
      this.error = false;
    } else {
      this.error = true;
    }
  }

  /**
       * Set pagination
       * @param event
       */
  pagination(event: any) {
    let list = document.getElementsByClassName('mat-paginator-range-label');
    let rows;
    if (event) {
      const currentLength = event.length;
      const currentPage = event.pageIndex;
      const currentSize = event.pageSize;

      let from = (currentSize * currentPage) + 1;
      let to = (currentLength < currentSize * (currentPage + 1))
        ? currentLength
        : currentSize * (currentPage + 1);
      let toFrom = (currentLength == 0) ? 0 : `${from} - ${to}`;
      let pageNumber = (currentLength == 0) ? '0 of 0' : `${currentPage + 1} of ${(currentLength % currentSize) > 0 ?
        Math.floor(currentLength / currentSize) + 1 : Math.floor(currentLength / currentSize)}`;
      rows = `Page ${pageNumber} (${toFrom} of ${currentLength})`;
    }
    if (list.length >= 1) {
      list[0].innerHTML = rows ? rows : '';
    }
  }

  /**
       * Determines action type
       * @param row
       * @param type
       */
  onActionClick(row: any, type: string) {
    const details = {
      item: row,
      type: type,
    };
    this.tableAction.emit(details);
  }

  ngOnChanges() {
    this.dataSource.data = this.tableData;
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
  }

  ngOnDestroy(): void {
    this._subscription?.unsubscribe();
  }

  /* Table filter */
  private _filterTable() {
    if (this.dataSet == 'alertRule') {
      this.dataSource.filterPredicate = (data: Element, filter: string): boolean => {
        return (
          data.alertId.toLocaleString().includes(filter) ||
          data.alertDesc.toLocaleLowerCase().includes(filter) ||
          data.class.toLocaleLowerCase().includes(filter) ||
          data.type.toLocaleLowerCase().includes(filter) ||
          data.alertSeverity.toLocaleLowerCase().includes(filter) ||
          data.alertCategory.toLocaleLowerCase().includes(filter)
        );
      };
    } else if (this.dataSet == 'feature') {
      this.dataSource.filterPredicate = (data: Element, filter: string): boolean => {
        return (
          data.menu.toLocaleLowerCase().includes(filter) ||
          data.featureName.toLocaleLowerCase().includes(filter) ||
          data.featureReleasedOn.toLocaleLowerCase().includes(filter) ||
          data.featureId.toLocaleString().includes(filter) ||
          data.featureType.toLocaleLowerCase().includes(filter)
        );
      };
    } else if (this.dataSet == 'userGroup') {
      this.dataSource.filterPredicate = (data: Element, filter: string): boolean => {
        return (
          data.index.toLocaleString().includes(filter) ||
          data.groupName.toLocaleLowerCase().includes(filter)
        );
      };
    } else if (this.dataSet == 'plantArchive' || this.dataSet == 'systemArchive') {
      this.dataSource.filterPredicate = (data: Element, filter: string): boolean => {
        return (
          data.index.toLocaleString().includes(filter) ||
          data.class.toLocaleLowerCase().includes(filter) ||
          data.action.toLocaleLowerCase().includes(filter)
        );
      };
    }
  }

  /* Determines whether page change on */
  private _getPaginateChange() {
    const value: PageEvent = {
      length: this.dataSource?.filteredData?.length,
      pageIndex: this.paginator.pageIndex,
      pageSize: this.paginator.pageSize
    };
    return value;
  }

  /* Search action */
  search(event: any) {
    this.searchAction.emit(event);
  }

  /* Tenant check */
  tenantCheck() {
    const tenantId = this.sharedService.getTenantId();
    this.allTenants = tenantId ? false : true;
  }

  getTagStatus(status: boolean) {
    if (status) {
      return { src: '../../../../assets/images/batch_tag_icon.svg', tooltip: 'Tagged' };
    } else {
      return { src: '../../../../assets/images/batch_untag_icon.svg', tooltip: 'Untagged' };
    }
  }
}
